
export const MALLING_SERVICE_SETTING = 'Malling service setting';
export const MALLING_SERVICE_SETTING_POPUP_TEXT = 'A newsletter is sent from this mail to clients from CRM -> Clients. ' +
  'You can add several maiks and the Founder will be able to select mail during the creation of the mailing list.';


export const HR_EMAIL = 'HR Email';
export const HR_EMAIL_POPUP_TEXT = 'Emails are sent to this email on behalf of employees when they create ' +
  'a request for Annual leave, Sick, Unpaid leave, Public holidays, Remote work.';


export const EMAIL_HR_NOTIFICATIONS= 'Email for HR notifications';
export const EMAIL_HR_NOTIFICATIONS_POPUP_TEXT = 'from this mail, notifications are sent to employees\' ' +
  'emails about changes in the status of requests for Annual leave, Sick, Unpaid leave, Public holidays, Remote work.';



export const PROJECT_NOTIFICATIONS_PM_DEPT = 'Email for List of Projects notifications PM Dept';
export const PROJECT_NOTIFICATIONS_PM_DEPT_POPUP_TEXT = 'from this email, an email is sent from the Projects or Request ' +
  'page from the Reminder settings to the email of the responsible user.';

export const ACADEMY_NOTIFICATIONS_COURSE = 'Email for List of Academy notifications';

export const EMAIL_CLIENT_TRACKING_LIST_NOTIFICATIONS = 'Email for Client  tracking list notifications';
export const EMAIL_CLIENT_TRACKING_LIST_NOTIFICATIONS_POPUP_TEXT = 'notifications about visa dates/birthdays, etc. ' +
  'are sent from this mail to the email of the user added to the Responsible for Client tracking list. ' +
  'And also if the project has an Est date set. Start Date, then a reminder is sent from this email to the ' +
  'Contact PM email 3 and 2 weeks before the start of the project.';

export const RESPONSIBLE_CLIENT_TRACKING_LIST = 'Responsible for Client tracking list';
export const RESPONSIBLE_CLIENT_TRACKING_LIST_POPUP_TEXT = 'a message is sent to this user about the dates ' +
  'of visas/birthdays, etc.';





// WEBPACK FOOTER //
// ./src/constants/companyFormText.js